<template>
  <div class="pop-up-container">
    <DxPopup
      :visible="isVisible"
      title="Attachment"
      :height="'auto'"
      width="50%"
      :wrapperAttr="{ class: 'css-v2 gc-popup gc-popup-sup-inv-files' }"
      :hide-on-outside-click="false"
      :showCloseButton="false"
      @hidden="popupHidden"
      :drag-enabled="false"
    >
      <DxToolbarItem
        v-for="(item, index) in getToolbarItems"
        :key="index"
        :widget="item.widget"
        :location="item.location"
        :visible="item.visible"
        :toolbar="item.position"
        :options="item.options"
      />
      <div class="css-v2 gc-popup-content">
        <div class="gc-popup-content-inner">
          <div class="gc-popup-header" v-if="isUserHasPermission">
            <div class="file-upload-container">
              <DxFileUploader
                select-button-text="Browse or Drag Here"
                label-text=""
                accept=".jpg, .jpeg, .png, .pdf , .docx, .doc, .xlsx, .xls, .csv"
                upload-mode="useForm"
                :show-file-list="false"
                :multiple="true"
                @value-changed="onFileUploaded"
                :tabIndex="-1"
                :allowed-file-extensions="[
                  '.jpg',
                  '.jpeg',
                  '.png',
                  '.pdf',
                  '.docx',
                  '.doc',
                  '.xlsx',
                  '.xls',
                  '.csv',
                ]"
                drop-zone=".file-upload-container"
              />

              <span>
                (Supported Formats : .jpg, .jpeg, .png, .pdf, .docx, .doc,
                .xlsx, .xls, .csv)
              </span>
            </div>
          </div>
          <div class="gc-popup-body" v-if="uploadedFiles.length > 0">
            <div
              class="file-list-container"
              v-for="(file, index) in uploadedFiles"
              v-bind:key="index"
            >
              <div class="file-item">
                <div
                  class="icon"
                  v-html="file.icon || getFileIcon(file.type)"
                  @click="previewFile(file)"
                ></div>
                <div class="file-name">
                  <span>{{ file.name }}</span>
                  <span>{{ file.date }}</span>
                </div>
                <div
                  class="file-action"
                  @click="removeFile(index)"
                  v-if="isUserHasPermission"
                >
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M23.3333 14.9998V14.3332C23.3333 13.3997 23.3333 12.933 23.1517 12.5765C22.9919 12.2629 22.7369 12.0079 22.4233 11.8482C22.0668 11.6665 21.6001 11.6665 20.6667 11.6665H19.3333C18.3999 11.6665 17.9332 11.6665 17.5767 11.8482C17.2631 12.0079 17.0081 12.2629 16.8483 12.5765C16.6667 12.933 16.6667 13.3997 16.6667 14.3332V14.9998M18.3333 19.5832V23.7498M21.6667 19.5832V23.7498M12.5 14.9998H27.5M25.8333 14.9998V24.3332C25.8333 25.7333 25.8333 26.4334 25.5608 26.9681C25.3212 27.4386 24.9387 27.821 24.4683 28.0607C23.9335 28.3332 23.2335 28.3332 21.8333 28.3332H18.1667C16.7665 28.3332 16.0665 28.3332 15.5317 28.0607C15.0613 27.821 14.6788 27.4386 14.4392 26.9681C14.1667 26.4334 14.1667 25.7333 14.1667 24.3332V14.9998"
                      stroke="#D92D20"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          <div class="gc-popup-body-empty" v-else>
            <span v-if="screenMode === 'review'">No files uploaded</span>
          </div>
        </div>
      </div>
    </DxPopup>

    <gcImagePreviewModal
      :visible="isImagePreviewVisible"
      :file="previewImage"
      @close="closeImagePreview"
      v-if="isImagePreviewVisible"
      @showLoading="showLoading"
    />
  </div>
</template>

<script>
import { DxFileUploader } from "devextreme-vue/file-uploader";
import resizeImage from "../../_helpers/image-processing/resizeImage";
import gcImagePreviewModal from "./gc-popup-sup-inv-img-preview.vue";
import { FeatureStorage } from "../../_services/storage";
import { SupplierInvoiceService } from "../../_services/api/purchasing/supplier-invoice.service";

export default {
  components: {
    DxFileUploader,
    gcImagePreviewModal,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    baseView: {
      type: Object,
      default: () => ({}),
    },
    allAttachements: {
      type: Array,
      default: () => [],
    },
    transactionRecordIDProp: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      uploadedFiles: [],
      isImagePreviewVisible: false,
      previewImage: null,
      screenMode: "create",
      TransactionRecordID: null,
      enableSaveButton: false,
    };
  },
  created() {
    if (this.baseView) {
      this.screenMode = this.baseView.mode || "create";
    }
    this.TransactionRecordID = this.transactionRecordIDProp || null;

    if (this.allAttachements.length > 0) {
      this.uploadedFiles = [...this.allAttachements];
      if (this.allAttachements[0].TransactionRecordID) {
        this.TransactionRecordID = this.allAttachements[0].TransactionRecordID;
      }
    }
    document.addEventListener("keydown", this.escHandler);
  },
  destroyed() {
    document.removeEventListener("keydown", this.escHandler);
  },
  methods: {
    showLoading(show) {
      this.$emit("showLoading", show);
    },
    /**
     * This method handles the Escape key press event.
     * It emits a close event to the parent component when the Escape key is pressed.
     * This is useful for closing the popup when the user presses Escape.
     * @param {KeyboardEvent} e - The keyboard event object
     */
    escHandler(e) {
      setTimeout(() => {
        if (e.code == "Escape") {
          this.$emit("close");
        }
      }, 100);
    },

    /**
     * This method is called when the popup is hidden.
     * It resets the uploadedFiles array and emits a close event.
     * This is useful for clearing the state when the popup is closed.
     * @returns {void}
     */
    async popupHidden() {
      let closeConfirmation = true;
      if (this.enableSaveButton) {
        closeConfirmation = await this.$confirm(
          "You’ve selected or modified attachments that haven’t been saved. Do you want to discard these changes and close?",
          "Close Confirmation"
        );
      }

      if (closeConfirmation) {
        this.onPopupClose();
      }
    },

    onPopupClose() {
      this.$nextTick(() => {
        this.uploadedFiles = [];

        if (this.screenMode === "review") {
          this.$emit("getAttachedFiles");
        }
        this.$emit("close");
      });
    },

    /**
     * @param e - The event object containing the uploaded files
     * This method processes the uploaded files, checking their types and resizing images if necessary.
     * It supports jpg, jpeg, png, and pdf file types.
     * For images, it resizes them and converts them to base64 format.
     * For PDFs, it converts them to base64 format.
     */
    async onFileUploaded(e) {
      if (e.value.length > 0) {
        this.enableSaveButton = true; // Enable save button when files are uploaded
        for (let index = 0; index < e.value.length; index++) {
          const file = e.value[index];
          const fileType = file.type;
          const fileName = file.name;

          if (fileType.startsWith("image/")) {
            // Handle image file (jpg/jpeg/png)
            let img = new Image();
            img.src = window.URL.createObjectURL(file);

            img.onload = async () => {
              const reader = new FileReader();

              reader.onload = async (onloadEvent) => {
                // const base64Image = onloadEvent.target.result;

                // Optional: Resize image if needed
                const resizedImageStr = resizeImage(img, file.type);

                this.uploadedFiles.push({
                  name: fileName,
                  type: fileType,
                  base64: resizedImageStr,
                  fileSize: onloadEvent.total,
                  date: new Date().toShortDateString(),
                });
              };

              reader.readAsDataURL(file);
            };
          } else if (fileType === "application/pdf") {
            // Handle PDF file
            const reader = new FileReader();

            reader.onload = (onloadEvent) => {
              const base64PDF = onloadEvent.target.result;
              this.uploadedFiles.push({
                name: fileName,
                type: fileType,
                base64: base64PDF,
                fileSize: onloadEvent.total,
                date: new Date().toShortDateString(),
                icon: '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 0.75H27C27.1212 0.75 27.2375 0.798088 27.3232 0.883789L38.1162 11.6768C38.2019 11.7625 38.25 11.8788 38.25 12V36C38.25 37.7949 36.7949 39.25 35 39.25H11C9.20507 39.25 7.75 37.7949 7.75 36V4C7.75 2.20507 9.20508 0.75 11 0.75Z" stroke="#D0D5DD" stroke-width="1.5"/><path d="M27 0.5V8C27 10.2091 28.7909 12 31 12H38.5" stroke="#D0D5DD" stroke-width="1.5"/><rect x="1" y="18" width="26" height="16" rx="2" fill="#D92D20"/><path d="M4.8323 30V22.7273H7.70162C8.25323 22.7273 8.72316 22.8326 9.11142 23.0433C9.49967 23.2517 9.7956 23.5417 9.9992 23.9134C10.2052 24.2827 10.3082 24.7088 10.3082 25.1918C10.3082 25.6747 10.204 26.1009 9.99565 26.4702C9.78732 26.8395 9.48547 27.1271 9.09011 27.3331C8.69712 27.5391 8.22127 27.642 7.66255 27.642H5.83372V26.4098H7.41397C7.7099 26.4098 7.95375 26.3589 8.14551 26.2571C8.33964 26.1529 8.48405 26.0097 8.57875 25.8274C8.67581 25.6428 8.72434 25.4309 8.72434 25.1918C8.72434 24.9503 8.67581 24.7396 8.57875 24.5597C8.48405 24.3774 8.33964 24.2365 8.14551 24.1371C7.95138 24.0353 7.70517 23.9844 7.40687 23.9844H6.36994V30H4.8323ZM13.885 30H11.3069V22.7273H13.9063C14.6379 22.7273 15.2676 22.8729 15.7955 23.1641C16.3235 23.4529 16.7295 23.8684 17.0136 24.4105C17.3 24.9527 17.4433 25.6013 17.4433 26.3565C17.4433 27.1141 17.3 27.7652 17.0136 28.3097C16.7295 28.8542 16.3211 29.272 15.7884 29.5632C15.2581 29.8544 14.6237 30 13.885 30ZM12.8445 28.6825H13.8211C14.2757 28.6825 14.658 28.602 14.9681 28.4411C15.2806 28.2777 15.515 28.0256 15.6713 27.6847C15.8299 27.3414 15.9092 26.8987 15.9092 26.3565C15.9092 25.8191 15.8299 25.38 15.6713 25.0391C15.515 24.6982 15.2818 24.4472 14.9717 24.2862C14.6615 24.1252 14.2792 24.0447 13.8247 24.0447H12.8445V28.6825ZM18.5823 30V22.7273H23.3976V23.995H20.1199V25.728H23.078V26.9957H20.1199V30H18.5823Z" fill="white"/></svg>',
              });
            };

            reader.readAsDataURL(file);
          } else if (
            fileType ===
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document" || // .docx
            fileType === "application/msword" || // .doc
            fileType === "application/vnd.ms-excel" || // .xls
            fileType ===
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || // .xlsx
            fileType === "text/csv" // .csv
          ) {
            const reader = new FileReader();

            reader.onload = (onloadEvent) => {
              const base64 = onloadEvent.target.result;

              this.uploadedFiles.push({
                name: fileName,
                type: fileType,
                base64,
                fileSize: onloadEvent.total,
                date: new Date().toShortDateString(),
                // icon: "<svg>...</svg>", // You can add relevant icons for Excel/Word
              });
            };

            reader.readAsDataURL(file);
          } else {
            // You can notify the user if needed
            this.$alert(
              `Unsupported file type: ${fileType}. Please upload .jpg, .jpeg, .png, .pdf, .docx, .doc, .xlsx, .xls, or .csv files.`,
              "Unsupported File Type"
            );
          }
        }
      }
    },

    /**
     * Get the file icon based on the MIME type.
     * @param fileType - The MIME type of the file
     */
    getFileIcon(fileType) {
      const fileIcons = {
        "application/pdf":
          '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 0.75H27C27.1212 0.75 27.2375 0.798088 27.3232 0.883789L38.1162 11.6768C38.2019 11.7625 38.25 11.8788 38.25 12V36C38.25 37.7949 36.7949 39.25 35 39.25H11C9.20507 39.25 7.75 37.7949 7.75 36V4C7.75 2.20507 9.20508 0.75 11 0.75Z" stroke="#D0D5DD" stroke-width="1.5"/><path d="M27 0.5V8C27 10.2091 28.7909 12 31 12H38.5" stroke="#D0D5DD" stroke-width="1.5"/><rect x="1" y="18" width="26" height="16" rx="2" fill="#D92D20"/><path d="M4.8323 30V22.7273H7.70162C8.25323 22.7273 8.72316 22.8326 9.11142 23.0433C9.49967 23.2517 9.7956 23.5417 9.9992 23.9134C10.2052 24.2827 10.3082 24.7088 10.3082 25.1918C10.3082 25.6747 10.204 26.1009 9.99565 26.4702C9.78732 26.8395 9.48547 27.1271 9.09011 27.3331C8.69712 27.5391 8.22127 27.642 7.66255 27.642H5.83372V26.4098H7.41397C7.7099 26.4098 7.95375 26.3589 8.14551 26.2571C8.33964 26.1529 8.48405 26.0097 8.57875 25.8274C8.67581 25.6428 8.72434 25.4309 8.72434 25.1918C8.72434 24.9503 8.67581 24.7396 8.57875 24.5597C8.48405 24.3774 8.33964 24.2365 8.14551 24.1371C7.95138 24.0353 7.70517 23.9844 7.40687 23.9844H6.36994V30H4.8323ZM13.885 30H11.3069V22.7273H13.9063C14.6379 22.7273 15.2676 22.8729 15.7955 23.1641C16.3235 23.4529 16.7295 23.8684 17.0136 24.4105C17.3 24.9527 17.4433 25.6013 17.4433 26.3565C17.4433 27.1141 17.3 27.7652 17.0136 28.3097C16.7295 28.8542 16.3211 29.272 15.7884 29.5632C15.2581 29.8544 14.6237 30 13.885 30ZM12.8445 28.6825H13.8211C14.2757 28.6825 14.658 28.602 14.9681 28.4411C15.2806 28.2777 15.515 28.0256 15.6713 27.6847C15.8299 27.3414 15.9092 26.8987 15.9092 26.3565C15.9092 25.8191 15.8299 25.38 15.6713 25.0391C15.515 24.6982 15.2818 24.4472 14.9717 24.2862C14.6615 24.1252 14.2792 24.0447 13.8247 24.0447H12.8445V28.6825ZM18.5823 30V22.7273H23.3976V23.995H20.1199V25.728H23.078V26.9957H20.1199V30H18.5823Z" fill="white"/></svg>',
        "image/jpeg":
          '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 0.75H27C27.1212 0.75 27.2375 0.798088 27.3232 0.883789L38.1162 11.6768C38.2019 11.7625 38.25 11.8788 38.25 12V36C38.25 37.7949 36.7949 39.25 35 39.25H11C9.20507 39.25 7.75 37.7949 7.75 36V4C7.75 2.20507 9.20508 0.75 11 0.75Z" stroke="#D0D5DD" stroke-width="1.5"/><path d="M27 0.5V8C27 10.2091 28.7909 12 31 12H38.5" stroke="#D0D5DD" stroke-width="1.5"/><rect x="1" y="18" width="26" height="16" rx="2" fill="#7F56D9"/><path d="M7.65146 22.7273H9.17134V27.7983C9.17134 28.267 9.06599 28.6742 8.85529 29.0199C8.64696 29.3655 8.35695 29.6319 7.98526 29.8189C7.61358 30.0059 7.18152 30.0994 6.6891 30.0994C6.25112 30.0994 5.8534 30.0225 5.49592 29.8686C5.1408 29.7124 4.85908 29.4756 4.65075 29.1584C4.44241 28.8388 4.33943 28.4375 4.3418 27.9545H5.87234C5.87707 28.1463 5.91613 28.3108 5.98952 28.4482C6.06528 28.5831 6.16826 28.6873 6.29847 28.7607C6.43105 28.8317 6.5873 28.8672 6.76722 28.8672C6.95662 28.8672 7.11642 28.8269 7.24663 28.7464C7.3792 28.6636 7.47982 28.5429 7.54847 28.3842C7.61713 28.2256 7.65146 28.0303 7.65146 27.7983V22.7273ZM10.4426 30V22.7273H13.312C13.8636 22.7273 14.3335 22.8326 14.7218 23.0433C15.11 23.2517 15.406 23.5417 15.6096 23.9134C15.8155 24.2827 15.9185 24.7088 15.9185 25.1918C15.9185 25.6747 15.8143 26.1009 15.606 26.4702C15.3977 26.8395 15.0958 27.1271 14.7005 27.3331C14.3075 27.5391 13.8316 27.642 13.2729 27.642H11.4441V26.4098H13.0243C13.3203 26.4098 13.5641 26.3589 13.7559 26.2571C13.95 26.1529 14.0944 26.0097 14.1891 25.8274C14.2862 25.6428 14.3347 25.4309 14.3347 25.1918C14.3347 24.9503 14.2862 24.7396 14.1891 24.5597C14.0944 24.3774 13.95 24.2365 13.7559 24.1371C13.5617 24.0353 13.3155 23.9844 13.0172 23.9844H11.9803V30H10.4426ZM21.7397 25.0781C21.69 24.9053 21.6201 24.7526 21.5302 24.62C21.4402 24.4851 21.3301 24.3714 21.1999 24.2791C21.0721 24.1844 20.9253 24.1122 20.7596 24.0625C20.5962 24.0128 20.4151 23.9879 20.2163 23.9879C19.8446 23.9879 19.5179 24.0803 19.2362 24.2649C18.9568 24.4496 18.739 24.7183 18.5827 25.071C18.4265 25.4214 18.3484 25.8499 18.3484 26.3565C18.3484 26.8632 18.4253 27.294 18.5792 27.6491C18.7331 28.0043 18.9509 28.2753 19.2326 28.4624C19.5143 28.647 19.8469 28.7393 20.2305 28.7393C20.5785 28.7393 20.8756 28.6778 21.1218 28.5547C21.3704 28.4292 21.5598 28.2528 21.69 28.0256C21.8226 27.7983 21.8888 27.5296 21.8888 27.2195L22.2013 27.2656H20.3263V26.108H23.3697V27.0241C23.3697 27.6634 23.2347 28.2126 22.9648 28.6719C22.695 29.1288 22.3233 29.4815 21.8498 29.7301C21.3763 29.9763 20.8342 30.0994 20.2234 30.0994C19.5415 30.0994 18.9426 29.9491 18.4265 29.6484C17.9104 29.3454 17.5079 28.9157 17.2191 28.3594C16.9326 27.8007 16.7894 27.1378 16.7894 26.3707C16.7894 25.7812 16.8746 25.2557 17.0451 24.794C17.2179 24.33 17.4594 23.937 17.7695 23.6151C18.0797 23.2931 18.4407 23.0481 18.8526 22.88C19.2646 22.7119 19.7108 22.6278 20.1914 22.6278C20.6033 22.6278 20.9869 22.6882 21.342 22.8089C21.6971 22.9273 22.012 23.0954 22.2866 23.3132C22.5636 23.531 22.7897 23.7902 22.9648 24.0909C23.14 24.3892 23.2525 24.7183 23.3022 25.0781H21.7397Z" fill="white"/></svg>',
        "image/png":
          '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 0.75H27C27.1212 0.75 27.2375 0.798088 27.3232 0.883789L38.1162 11.6768C38.2019 11.7625 38.25 11.8788 38.25 12V36C38.25 37.7949 36.7949 39.25 35 39.25H11C9.20507 39.25 7.75 37.7949 7.75 36V4C7.75 2.20507 9.20508 0.75 11 0.75Z" stroke="#D0D5DD" stroke-width="1.5"/><path d="M27 0.5V8C27 10.2091 28.7909 12 31 12H38.5" stroke="#D0D5DD" stroke-width="1.5"/><rect x="1" y="18" width="28" height="16" rx="2" fill="#7F56D9"/><path d="M4.91433 30V22.7273H7.78365C8.33526 22.7273 8.80519 22.8326 9.19345 23.0433C9.58171 23.2517 9.87763 23.5417 10.0812 23.9134C10.2872 24.2827 10.3902 24.7088 10.3902 25.1918C10.3902 25.6747 10.286 26.1009 10.0777 26.4702C9.86935 26.8395 9.5675 27.1271 9.17214 27.3331C8.77915 27.5391 8.3033 27.642 7.74458 27.642H5.91575V26.4098H7.496C7.79193 26.4098 8.03578 26.3589 8.22754 26.2571C8.42167 26.1529 8.56608 26.0097 8.66078 25.8274C8.75784 25.6428 8.80637 25.4309 8.80637 25.1918C8.80637 24.9503 8.75784 24.7396 8.66078 24.5597C8.56608 24.3774 8.42167 24.2365 8.22754 24.1371C8.03341 24.0353 7.7872 23.9844 7.4889 23.9844H6.45197V30H4.91433ZM17.472 22.7273V30H16.1439L12.9798 25.4226H12.9266V30H11.3889V22.7273H12.7384L15.8776 27.3011H15.9415V22.7273H17.472ZM23.5649 25.0781C23.5152 24.9053 23.4453 24.7526 23.3554 24.62C23.2654 24.4851 23.1553 24.3714 23.0251 24.2791C22.8973 24.1844 22.7505 24.1122 22.5848 24.0625C22.4214 24.0128 22.2403 23.9879 22.0415 23.9879C21.6698 23.9879 21.3431 24.0803 21.0613 24.2649C20.782 24.4496 20.5642 24.7183 20.4079 25.071C20.2517 25.4214 20.1736 25.8499 20.1736 26.3565C20.1736 26.8632 20.2505 27.294 20.4044 27.6491C20.5583 28.0043 20.7761 28.2753 21.0578 28.4624C21.3395 28.647 21.6721 28.7393 22.0557 28.7393C22.4037 28.7393 22.7008 28.6778 22.947 28.5547C23.1956 28.4292 23.385 28.2528 23.5152 28.0256C23.6478 27.7983 23.714 27.5296 23.714 27.2195L24.0265 27.2656H22.1515V26.108H25.1949V27.0241C25.1949 27.6634 25.0599 28.2126 24.79 28.6719C24.5202 29.1288 24.1485 29.4815 23.675 29.7301C23.2015 29.9763 22.6594 30.0994 22.0486 30.0994C21.3667 30.0994 20.7678 29.9491 20.2517 29.6484C19.7356 29.3454 19.3331 28.9157 19.0443 28.3594C18.7578 27.8007 18.6146 27.1378 18.6146 26.3707C18.6146 25.7812 18.6998 25.2557 18.8703 24.794C19.0431 24.33 19.2846 23.937 19.5947 23.6151C19.9049 23.2931 20.2659 23.0481 20.6778 22.88C21.0898 22.7119 21.536 22.6278 22.0166 22.6278C22.4285 22.6278 22.8121 22.6882 23.1672 22.8089C23.5223 22.9273 23.8372 23.0954 24.1118 23.3132C24.3888 23.531 24.6148 23.7902 24.79 24.0909C24.9652 24.3892 25.0777 24.7183 25.1274 25.0781H23.5649Z" fill="white"/></svg>',
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
          '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 0.75H27C27.1212 0.75 27.2375 0.798088 27.3232 0.883789L38.1162 11.6768C38.2019 11.7625 38.25 11.8788 38.25 12V36C38.25 37.7949 36.7949 39.25 35 39.25H11C9.20507 39.25 7.75 37.7949 7.75 36V4C7.75 2.20507 9.20508 0.75 11 0.75Z" stroke="#D0D5DD" stroke-width="1.5"/><path d="M27 0.5V8C27 10.2091 28.7909 12 31 12H38.5" stroke="#D0D5DD" stroke-width="1.5"/><rect x="1" y="18" width="36" height="16" rx="2" fill="#155EEF"/><path d="M7.40554 30H4.82741V22.7273H7.42685C8.15838 22.7273 8.78812 22.8729 9.31605 23.1641C9.84399 23.4529 10.25 23.8684 10.5341 24.4105C10.8205 24.9527 10.9638 25.6013 10.9638 26.3565C10.9638 27.1141 10.8205 27.7652 10.5341 28.3097C10.25 28.8542 9.84162 29.272 9.30895 29.5632C8.77865 29.8544 8.14418 30 7.40554 30ZM6.36506 28.6825H7.34162C7.79616 28.6825 8.1785 28.602 8.48864 28.4411C8.80114 28.2777 9.03551 28.0256 9.19176 27.6847C9.35038 27.3414 9.42969 26.8987 9.42969 26.3565C9.42969 25.8191 9.35038 25.38 9.19176 25.0391C9.03551 24.6982 8.80232 24.4472 8.49219 24.2862C8.18205 24.1252 7.79972 24.0447 7.34517 24.0447H6.36506V28.6825ZM18.786 26.3636C18.786 27.1567 18.6357 27.8314 18.335 28.3878C18.0368 28.9441 17.6296 29.3691 17.1135 29.6626C16.5997 29.9538 16.0221 30.0994 15.3805 30.0994C14.7342 30.0994 14.1542 29.9527 13.6404 29.6591C13.1267 29.3655 12.7207 28.9406 12.4224 28.3842C12.1241 27.8279 11.975 27.1544 11.975 26.3636C11.975 25.5705 12.1241 24.8958 12.4224 24.3395C12.7207 23.7831 13.1267 23.3594 13.6404 23.0682C14.1542 22.7746 14.7342 22.6278 15.3805 22.6278C16.0221 22.6278 16.5997 22.7746 17.1135 23.0682C17.6296 23.3594 18.0368 23.7831 18.335 24.3395C18.6357 24.8958 18.786 25.5705 18.786 26.3636ZM17.2271 26.3636C17.2271 25.8499 17.1502 25.4167 16.9963 25.0639C16.8448 24.7112 16.6305 24.4437 16.3535 24.2614C16.0765 24.0791 15.7522 23.9879 15.3805 23.9879C15.0088 23.9879 14.6845 24.0791 14.4075 24.2614C14.1305 24.4437 13.9151 24.7112 13.7612 25.0639C13.6097 25.4167 13.5339 25.8499 13.5339 26.3636C13.5339 26.8774 13.6097 27.3106 13.7612 27.6634C13.9151 28.0161 14.1305 28.2836 14.4075 28.4659C14.6845 28.6482 15.0088 28.7393 15.3805 28.7393C15.7522 28.7393 16.0765 28.6482 16.3535 28.4659C16.6305 28.2836 16.8448 28.0161 16.9963 27.6634C17.1502 27.3106 17.2271 26.8774 17.2271 26.3636ZM26.342 25.2734H24.7866C24.7582 25.0722 24.7002 24.8935 24.6126 24.7372C24.525 24.5786 24.4125 24.4437 24.2752 24.3324C24.1379 24.2211 23.9793 24.1359 23.7994 24.0767C23.6218 24.0175 23.4289 23.9879 23.2205 23.9879C22.8441 23.9879 22.5162 24.0814 22.2369 24.2685C21.9575 24.4531 21.7409 24.723 21.587 25.0781C21.4331 25.4309 21.3562 25.8594 21.3562 26.3636C21.3562 26.8821 21.4331 27.3177 21.587 27.6705C21.7433 28.0232 21.9611 28.2895 22.2404 28.4695C22.5198 28.6494 22.8429 28.7393 23.2099 28.7393C23.4158 28.7393 23.6064 28.7121 23.7816 28.6577C23.9592 28.6032 24.1166 28.5239 24.2539 28.4197C24.3912 28.3132 24.5049 28.1842 24.5948 28.0327C24.6871 27.8812 24.7511 27.7083 24.7866 27.5142L26.342 27.5213C26.3017 27.8551 26.2011 28.1771 26.0401 28.4872C25.8815 28.795 25.6673 29.0708 25.3974 29.3146C25.1299 29.5561 24.8103 29.7479 24.4386 29.8899C24.0692 30.0296 23.6514 30.0994 23.185 30.0994C22.5363 30.0994 21.9563 29.9527 21.445 29.6591C20.936 29.3655 20.5335 28.9406 20.2376 28.3842C19.944 27.8279 19.7972 27.1544 19.7972 26.3636C19.7972 25.5705 19.9464 24.8958 20.2447 24.3395C20.543 23.7831 20.9478 23.3594 21.4592 23.0682C21.9705 22.7746 22.5458 22.6278 23.185 22.6278C23.6064 22.6278 23.997 22.687 24.3569 22.8054C24.7191 22.9238 25.0399 23.0966 25.3192 23.3239C25.5986 23.5488 25.8259 23.8246 26.0011 24.1513C26.1786 24.478 26.2923 24.852 26.342 25.2734ZM28.7301 22.7273L30.1967 25.206H30.2536L31.7273 22.7273H33.4638L31.2443 26.3636L33.5135 30H31.745L30.2536 27.5178H30.1967L28.7053 30H26.9439L29.2202 26.3636L26.9865 22.7273H28.7301Z" fill="white"/></svg>',
        "application/msword":
          '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 0.75H27C27.1212 0.75 27.2375 0.798088 27.3232 0.883789L38.1162 11.6768C38.2019 11.7625 38.25 11.8788 38.25 12V36C38.25 37.7949 36.7949 39.25 35 39.25H11C9.20507 39.25 7.75 37.7949 7.75 36V4C7.75 2.20507 9.20508 0.75 11 0.75Z" stroke="#D0D5DD" stroke-width="1.5"/><path d="M27 0.5V8C27 10.2091 28.7909 12 31 12H38.5" stroke="#D0D5DD" stroke-width="1.5"/><rect x="1" y="18" width="29" height="16" rx="2" fill="#155EEF"/><path d="M7.40163 30H4.82351V22.7273H7.42294C8.15447 22.7273 8.78421 22.8729 9.31214 23.1641C9.84008 23.4529 10.2461 23.8684 10.5302 24.4105C10.8166 24.9527 10.9599 25.6013 10.9599 26.3565C10.9599 27.1141 10.8166 27.7652 10.5302 28.3097C10.2461 28.8542 9.83771 29.272 9.30504 29.5632C8.77474 29.8544 8.14027 30 7.40163 30ZM6.36115 28.6825H7.33771C7.79226 28.6825 8.1746 28.602 8.48473 28.4411C8.79723 28.2777 9.03161 28.0256 9.18786 27.6847C9.34647 27.3414 9.42578 26.8987 9.42578 26.3565C9.42578 25.8191 9.34647 25.38 9.18786 25.0391C9.03161 24.6982 8.79841 24.4472 8.48828 24.2862C8.17815 24.1252 7.79581 24.0447 7.34126 24.0447H6.36115V28.6825ZM18.7821 26.3636C18.7821 27.1567 18.6318 27.8314 18.3311 28.3878C18.0328 28.9441 17.6257 29.3691 17.1096 29.6626C16.5958 29.9538 16.0182 30.0994 15.3766 30.0994C14.7303 30.0994 14.1503 29.9527 13.6365 29.6591C13.1228 29.3655 12.7168 28.9406 12.4185 28.3842C12.1202 27.8279 11.9711 27.1544 11.9711 26.3636C11.9711 25.5705 12.1202 24.8958 12.4185 24.3395C12.7168 23.7831 13.1228 23.3594 13.6365 23.0682C14.1503 22.7746 14.7303 22.6278 15.3766 22.6278C16.0182 22.6278 16.5958 22.7746 17.1096 23.0682C17.6257 23.3594 18.0328 23.7831 18.3311 24.3395C18.6318 24.8958 18.7821 25.5705 18.7821 26.3636ZM17.2232 26.3636C17.2232 25.8499 17.1462 25.4167 16.9924 25.0639C16.8408 24.7112 16.6266 24.4437 16.3496 24.2614C16.0726 24.0791 15.7483 23.9879 15.3766 23.9879C15.0049 23.9879 14.6806 24.0791 14.4036 24.2614C14.1266 24.4437 13.9112 24.7112 13.7573 25.0639C13.6058 25.4167 13.53 25.8499 13.53 26.3636C13.53 26.8774 13.6058 27.3106 13.7573 27.6634C13.9112 28.0161 14.1266 28.2836 14.4036 28.4659C14.6806 28.6482 15.0049 28.7393 15.3766 28.7393C15.7483 28.7393 16.0726 28.6482 16.3496 28.4659C16.6266 28.2836 16.8408 28.0161 16.9924 27.6634C17.1462 27.3106 17.2232 26.8774 17.2232 26.3636ZM26.3381 25.2734H24.7827C24.7543 25.0722 24.6963 24.8935 24.6087 24.7372C24.5211 24.5786 24.4086 24.4437 24.2713 24.3324C24.134 24.2211 23.9754 24.1359 23.7955 24.0767C23.6179 24.0175 23.425 23.9879 23.2166 23.9879C22.8402 23.9879 22.5123 24.0814 22.233 24.2685C21.9536 24.4531 21.737 24.723 21.5831 25.0781C21.4292 25.4309 21.3523 25.8594 21.3523 26.3636C21.3523 26.8821 21.4292 27.3177 21.5831 27.6705C21.7393 28.0232 21.9571 28.2895 22.2365 28.4695C22.5159 28.6494 22.839 28.7393 23.206 28.7393C23.4119 28.7393 23.6025 28.7121 23.7777 28.6577C23.9553 28.6032 24.1127 28.5239 24.25 28.4197C24.3873 28.3132 24.5009 28.1842 24.5909 28.0327C24.6832 27.8812 24.7472 27.7083 24.7827 27.5142L26.3381 27.5213C26.2978 27.8551 26.1972 28.1771 26.0362 28.4872C25.8776 28.795 25.6634 29.0708 25.3935 29.3146C25.1259 29.5561 24.8063 29.7479 24.4347 29.8899C24.0653 30.0296 23.6475 30.0994 23.1811 30.0994C22.5324 30.0994 21.9524 29.9527 21.4411 29.6591C20.9321 29.3655 20.5296 28.9406 20.2337 28.3842C19.9401 27.8279 19.7933 27.1544 19.7933 26.3636C19.7933 25.5705 19.9425 24.8958 20.2408 24.3395C20.5391 23.7831 20.9439 23.3594 21.4553 23.0682C21.9666 22.7746 22.5419 22.6278 23.1811 22.6278C23.6025 22.6278 23.9931 22.687 24.353 22.8054C24.7152 22.9238 25.036 23.0966 25.3153 23.3239C25.5947 23.5488 25.822 23.8246 25.9972 24.1513C26.1747 24.478 26.2884 24.852 26.3381 25.2734Z" fill="white"/></svg>',
        "application/vnd.ms-excel":
          '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 0.75H27C27.1212 0.75 27.2375 0.798088 27.3232 0.883789L38.1162 11.6768C38.2019 11.7625 38.25 11.8788 38.25 12V36C38.25 37.7949 36.7949 39.25 35 39.25H11C9.20507 39.25 7.75 37.7949 7.75 36V4C7.75 2.20507 9.20508 0.75 11 0.75Z" stroke="#D0D5DD" stroke-width="1.5"/><path d="M27 0.5V8C27 10.2091 28.7909 12 31 12H38.5" stroke="#D0D5DD" stroke-width="1.5"/><rect x="1" y="18" width="26" height="16" rx="2" fill="#079455"/><path d="M6.38636 22.7273L7.85298 25.206H7.9098L9.38352 22.7273H11.12L8.90057 26.3636L11.1697 30H9.40128L7.9098 27.5178H7.85298L6.36151 30H4.60014L6.87642 26.3636L4.64276 22.7273H6.38636ZM12.093 30V22.7273H13.6307V28.7322H16.7486V30H12.093ZM21.7122 24.8189C21.6838 24.5324 21.5618 24.3099 21.3464 24.1513C21.131 23.9927 20.8386 23.9134 20.4693 23.9134C20.2183 23.9134 20.0065 23.9489 19.8336 24.0199C19.6608 24.0885 19.5282 24.1844 19.4359 24.3075C19.3459 24.4306 19.301 24.5703 19.301 24.7266C19.2962 24.8568 19.3234 24.9704 19.3826 25.0675C19.4442 25.1645 19.5282 25.2486 19.6348 25.3196C19.7413 25.3883 19.8644 25.4486 20.0041 25.5007C20.1438 25.5504 20.2929 25.593 20.4515 25.6286L21.1049 25.7848C21.4222 25.8558 21.7134 25.9505 21.9785 26.0689C22.2437 26.1873 22.4733 26.3329 22.6674 26.5057C22.8616 26.6785 23.0119 26.8821 23.1184 27.1165C23.2273 27.3509 23.283 27.6196 23.2853 27.9226C23.283 28.3677 23.1693 28.7536 22.9444 29.0803C22.7219 29.4046 22.3999 29.6567 21.9785 29.8366C21.5595 30.0142 21.054 30.103 20.4622 30.103C19.8751 30.103 19.3637 30.013 18.9281 29.8331C18.4949 29.6532 18.1563 29.3868 17.9125 29.0341C17.671 28.679 17.5443 28.2398 17.5325 27.7166H19.0204C19.037 27.9605 19.1068 28.1641 19.2299 28.3274C19.3554 28.4884 19.5223 28.6103 19.7306 28.6932C19.9413 28.7737 20.1793 28.8139 20.4444 28.8139C20.7048 28.8139 20.9309 28.776 21.1227 28.7003C21.3168 28.6245 21.4672 28.5192 21.5737 28.3842C21.6802 28.2493 21.7335 28.0942 21.7335 27.919C21.7335 27.7557 21.685 27.6184 21.5879 27.5071C21.4932 27.3958 21.3535 27.3011 21.1689 27.223C20.9866 27.1449 20.7628 27.0739 20.4977 27.0099L19.7058 26.8111C19.0926 26.6619 18.6085 26.4287 18.2534 26.1115C17.8983 25.7943 17.7219 25.367 17.7243 24.8295C17.7219 24.3892 17.8391 24.0045 18.0758 23.6754C18.3149 23.3464 18.6428 23.0895 19.0595 22.9048C19.4761 22.7202 19.9496 22.6278 20.4799 22.6278C21.0197 22.6278 21.4908 22.7202 21.8933 22.9048C22.2981 23.0895 22.613 23.3464 22.8379 23.6754C23.0628 24.0045 23.1788 24.3857 23.1859 24.8189H21.7122Z" fill="white"/></svg>',
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
          '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 0.75H27C27.1212 0.75 27.2375 0.798088 27.3232 0.883789L38.1162 11.6768C38.2019 11.7625 38.25 11.8788 38.25 12V36C38.25 37.7949 36.7949 39.25 35 39.25H11C9.20507 39.25 7.75 37.7949 7.75 36V4C7.75 2.20507 9.20508 0.75 11 0.75Z" stroke="#D0D5DD" stroke-width="1.5"/><path d="M27 0.5V8C27 10.2091 28.7909 12 31 12H38.5" stroke="#D0D5DD" stroke-width="1.5"/><rect x="1" y="18" width="33" height="16" rx="2" fill="#079455"/><path d="M6.31214 22.7273L7.77876 25.206H7.83558L9.3093 22.7273H11.0458L8.82635 26.3636L11.0955 30H9.32706L7.83558 27.5178H7.77876L6.28729 30H4.52592L6.8022 26.3636L4.56854 22.7273H6.31214ZM12.0188 30V22.7273H13.5565V28.7322H16.6744V30H12.0188ZM21.638 24.8189C21.6096 24.5324 21.4876 24.3099 21.2722 24.1513C21.0568 23.9927 20.7644 23.9134 20.3951 23.9134C20.1441 23.9134 19.9322 23.9489 19.7594 24.0199C19.5866 24.0885 19.454 24.1844 19.3617 24.3075C19.2717 24.4306 19.2267 24.5703 19.2267 24.7266C19.222 24.8568 19.2492 24.9704 19.3084 25.0675C19.37 25.1645 19.454 25.2486 19.5605 25.3196C19.6671 25.3883 19.7902 25.4486 19.9299 25.5007C20.0695 25.5504 20.2187 25.593 20.3773 25.6286L21.0307 25.7848C21.348 25.8558 21.6391 25.9505 21.9043 26.0689C22.1694 26.1873 22.3991 26.3329 22.5932 26.5057C22.7873 26.6785 22.9377 26.8821 23.0442 27.1165C23.1531 27.3509 23.2087 27.6196 23.2111 27.9226C23.2087 28.3677 23.0951 28.7536 22.8702 29.0803C22.6477 29.4046 22.3257 29.6567 21.9043 29.8366C21.4853 30.0142 20.9798 30.103 20.388 30.103C19.8008 30.103 19.2895 30.013 18.8539 29.8331C18.4206 29.6532 18.0821 29.3868 17.8382 29.0341C17.5968 28.679 17.4701 28.2398 17.4583 27.7166H18.9462C18.9628 27.9605 19.0326 28.1641 19.1557 28.3274C19.2812 28.4884 19.4481 28.6103 19.6564 28.6932C19.8671 28.7737 20.1051 28.8139 20.3702 28.8139C20.6306 28.8139 20.8567 28.776 21.0485 28.7003C21.2426 28.6245 21.3929 28.5192 21.4995 28.3842C21.606 28.2493 21.6593 28.0942 21.6593 27.919C21.6593 27.7557 21.6107 27.6184 21.5137 27.5071C21.419 27.3958 21.2793 27.3011 21.0946 27.223C20.9123 27.1449 20.6886 27.0739 20.4235 27.0099L19.6316 26.8111C19.0184 26.6619 18.5343 26.4287 18.1792 26.1115C17.824 25.7943 17.6477 25.367 17.65 24.8295C17.6477 24.3892 17.7649 24.0045 18.0016 23.6754C18.2407 23.3464 18.5686 23.0895 18.9853 22.9048C19.4019 22.7202 19.8754 22.6278 20.4057 22.6278C20.9455 22.6278 21.4166 22.7202 21.8191 22.9048C22.2239 23.0895 22.5388 23.3464 22.7637 23.6754C22.9886 24.0045 23.1046 24.3857 23.1117 24.8189H21.638ZM25.6871 22.7273L27.1538 25.206H27.2106L28.6843 22.7273H30.4208L28.2013 26.3636L30.4705 30H28.7021L27.2106 27.5178H27.1538L25.6623 30H23.9009L26.1772 26.3636L23.9435 22.7273H25.6871Z" fill="white"/></svg>',
        "text/csv":
          '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 0.75H27C27.1212 0.75 27.2375 0.798088 27.3232 0.883789L38.1162 11.6768C38.2019 11.7625 38.25 11.8788 38.25 12V36C38.25 37.7949 36.7949 39.25 35 39.25H11C9.20507 39.25 7.75 37.7949 7.75 36V4C7.75 2.20507 9.20508 0.75 11 0.75Z" stroke="#D0D5DD" stroke-width="1.5"/><path d="M27 0.5V8C27 10.2091 28.7909 12 31 12H38.5" stroke="#D0D5DD" stroke-width="1.5"/><rect x="1" y="18" width="28" height="16" rx="2" fill="#079455"/><path d="M11.2726 25.2734H9.71724C9.68883 25.0722 9.63083 24.8935 9.54324 24.7372C9.45564 24.5786 9.34319 24.4437 9.20588 24.3324C9.06857 24.2211 8.90995 24.1359 8.73002 24.0767C8.55247 24.0175 8.35952 23.9879 8.15119 23.9879C7.77477 23.9879 7.44688 24.0814 7.16752 24.2685C6.88817 24.4531 6.67155 24.723 6.51767 25.0781C6.36378 25.4309 6.28684 25.8594 6.28684 26.3636C6.28684 26.8821 6.36378 27.3177 6.51767 27.6705C6.67392 28.0232 6.89172 28.2895 7.17108 28.4695C7.45043 28.6494 7.77359 28.7393 8.14054 28.7393C8.3465 28.7393 8.53708 28.7121 8.71227 28.6577C8.88983 28.6032 9.04726 28.5239 9.18457 28.4197C9.32188 28.3132 9.43552 28.1842 9.52548 28.0327C9.61781 27.8812 9.68173 27.7083 9.71724 27.5142L11.2726 27.5213C11.2324 27.8551 11.1318 28.1771 10.9708 28.4872C10.8122 28.795 10.5979 29.0708 10.328 29.3146C10.0605 29.5561 9.74092 29.7479 9.36923 29.8899C8.99991 30.0296 8.58206 30.0994 8.11568 30.0994C7.467 30.0994 6.88699 29.9527 6.37562 29.6591C5.86663 29.3655 5.46416 28.9406 5.16824 28.3842C4.87467 27.8279 4.72789 27.1544 4.72789 26.3636C4.72789 25.5705 4.87704 24.8958 5.17534 24.3395C5.47363 23.7831 5.87846 23.3594 6.38983 23.0682C6.90119 22.7746 7.47647 22.6278 8.11568 22.6278C8.53708 22.6278 8.9277 22.687 9.28755 22.8054C9.64977 22.9238 9.97056 23.0966 10.2499 23.3239C10.5293 23.5488 10.7565 23.8246 10.9317 24.1513C11.1093 24.478 11.2229 24.852 11.2726 25.2734ZM16.3206 24.8189C16.2922 24.5324 16.1702 24.3099 15.9548 24.1513C15.7394 23.9927 15.447 23.9134 15.0777 23.9134C14.8267 23.9134 14.6148 23.9489 14.442 24.0199C14.2692 24.0885 14.1366 24.1844 14.0443 24.3075C13.9543 24.4306 13.9094 24.5703 13.9094 24.7266C13.9046 24.8568 13.9318 24.9704 13.991 25.0675C14.0526 25.1645 14.1366 25.2486 14.2432 25.3196C14.3497 25.3883 14.4728 25.4486 14.6125 25.5007C14.7522 25.5504 14.9013 25.593 15.0599 25.6286L15.7133 25.7848C16.0306 25.8558 16.3218 25.9505 16.5869 26.0689C16.8521 26.1873 17.0817 26.3329 17.2758 26.5057C17.47 26.6785 17.6203 26.8821 17.7268 27.1165C17.8357 27.3509 17.8914 27.6196 17.8937 27.9226C17.8914 28.3677 17.7777 28.7536 17.5528 29.0803C17.3303 29.4046 17.0083 29.6567 16.5869 29.8366C16.1679 30.0142 15.6624 30.103 15.0706 30.103C14.4835 30.103 13.9721 30.013 13.5365 29.8331C13.1032 29.6532 12.7647 29.3868 12.5209 29.0341C12.2794 28.679 12.1527 28.2398 12.1409 27.7166H13.6288C13.6454 27.9605 13.7152 28.1641 13.8383 28.3274C13.9638 28.4884 14.1307 28.6103 14.339 28.6932C14.5497 28.7737 14.7877 28.8139 15.0528 28.8139C15.3132 28.8139 15.5393 28.776 15.7311 28.7003C15.9252 28.6245 16.0756 28.5192 16.1821 28.3842C16.2886 28.2493 16.3419 28.0942 16.3419 27.919C16.3419 27.7557 16.2934 27.6184 16.1963 27.5071C16.1016 27.3958 15.9619 27.3011 15.7773 27.223C15.595 27.1449 15.3712 27.0739 15.1061 27.0099L14.3142 26.8111C13.701 26.6619 13.2169 26.4287 12.8618 26.1115C12.5067 25.7943 12.3303 25.367 12.3327 24.8295C12.3303 24.3892 12.4475 24.0045 12.6842 23.6754C12.9233 23.3464 13.2512 23.0895 13.6679 22.9048C14.0845 22.7202 14.558 22.6278 15.0883 22.6278C15.6281 22.6278 16.0992 22.7202 16.5017 22.9048C16.9065 23.0895 17.2214 23.3464 17.4463 23.6754C17.6712 24.0045 17.7872 24.3857 17.7943 24.8189H16.3206ZM20.2419 22.7273L21.9997 28.2528H22.0672L23.8286 22.7273H25.5331L23.026 30H21.0445L18.5338 22.7273H20.2419Z" fill="white"/></svg>',
      };
      return (
        fileIcons[fileType] ||
        '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 0.75H27C27.1212 0.75 27.2375 0.798088 27.3232 0.883789L38.1162 11.6768C38.2019 11.7625 38.25 11.8788 38.25 12V36C38.25 37.7949 36.7949 39.25 35 39.25H11C9.20507 39.25 7.75 37.7949 7.75 36V4C7.75 2.20507 9.20508 0.75 11 0.75Z" stroke="#D0D5DD" stroke-width="1.5"/><path d="M27 0.5V8C27 10.2091 28.7909 12 31 12H38.5" stroke="#D0D5DD" stroke-width="1.5"/><rect x="1.5" y="18" width="27" height="16" rx="2" fill="#35BAF6"/><path d="M5.40749 30V22.7273H10.2228V23.995H6.94513V25.728H9.90323V26.9957H6.94513V30H5.40749ZM12.7947 22.7273V30H11.2571V22.7273H12.7947ZM14.0598 30V22.7273H15.5975V28.7322H18.7154V30H14.0598ZM19.7337 30V22.7273H24.6342V23.995H21.2713V25.728H24.3821V26.9957H21.2713V28.7322H24.6484V30H19.7337Z" fill="white"/></svg>'
      );
    },

    /**
     * @param index - The index of the file to remove
     * This method prompts the user for confirmation before removing a file.
     * If confirmed, it removes the file from the uploadedFiles array.
     * It uses the $confirm method to show a confirmation dialog.
     */
    async removeFile(index) {
      const confirmDelete = await this.$confirm(
        "Are you sure you want to delete this file? This action cannot be undone.",
        "Delete File"
      );
      if (confirmDelete) {
        this.uploadedFiles.splice(index, 1);
        this.enableSaveButton = true;
      }
    },

    /**
     * @param file - The file object to preview
     * This method opens a new tab to preview the file.
     * It supports PDF and image files (jpg, jpeg, png).
     * For PDF files, it embeds the PDF in an iframe.
     * For image files, it displays the image directly.
     * If the file type is unsupported, it shows an alert.
     */
    previewFile(file) {
      if (file.type === "application/pdf") {
        // Open PDF in new tab
        if (file.MediaUrl) {
          window.open(file.MediaUrl, "_blank", "noopener,noreferrer");
        } else {
          const newTab = window.open();
          newTab.document.write(
            `<iframe src="${file.base64}" width="100%" height="100%" style="border:none;"></iframe>`
          );
        }
      } else if (file.type.startsWith("image/")) {
        // Open image in preview modal
        this.previewImage = file;
        this.isImagePreviewVisible = true;
      } else {
        // Unsupported file type
        if (file.DownloadApiUrl) {
          const blobUrl = file.DownloadApiUrl;
          this.$emit("showLoading", true);
          fetch(blobUrl)
            .then((response) => response.blob())
            .then((blob) => {
              const url = URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.download = file.name || "download-" + new Date().getTime(); // You can set a filename
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              URL.revokeObjectURL(url);
              this.$emit("showLoading", false);
            })
            .catch(() => {
              this.$emit("showLoading", false);
            });
        } else {
          const link = document.createElement("a");
          link.href = file.base64;
          link.download = file.name || "download";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    },

    /**
     * Close the image preview modal.
     */
    closeImagePreview() {
      this.isImagePreviewVisible = false;
      this.previewImage = null;
    },

    /**
     * Save the uploaded files.
     * If in create mode, it emits the uploaded files.
     * If in edit mode, it updates the transaction media metadata.
     */
    async onSaveAttachments() {
      if (this.screenMode === "create") {
        if (this.uploadedFiles.length > 0) {
          this.$emit("saveImage", this.uploadedFiles);
        }

        this.$nextTick(() => {
          this.onPopupClose();
        });
      } else {
        this.$emit("showLoading", true);
        const payload = {
          TransactionRecordId: this.TransactionRecordID,
          TransactionType: "SupplierInvoice",
          TransactionMediaMetas: this.uploadedFiles.map((file) => ({
            TransactionRecordId: this.TransactionRecordID,
            TransactionType: "SupplierInvoice",
            ContentType: file.type,
            FileName: file.name,
            FileSize: file.size,
            MediaBase64String: file.base64 || undefined,
            RecordId: file.RecordId || "00000000-0000-0000-0000-000000000000",
          })),
        };

        try {
          const updatedFiles =
            await SupplierInvoiceService.updateTransactionMediaMeta(payload);

          if (updatedFiles && updatedFiles.status === 200) {
            this.$notify({
              type: "success",
              message: "Files updated successfully.",
            });
          }
          this.$nextTick(() => {
            this.onPopupClose();
          });
        } catch (error) {
          this.$emit("showLoading", false);
          this.$emit("showServerError", {
            err: error,
            msg: "Failed to update files.",
            time: new Date().getTime(),
          });
        } finally {
          this.$emit("showLoading", false);
        }
      }
    },
  },
  computed: {
    /**
     * Check if the popup is visible.
     */
    isVisible() {
      return this.visible;
    },
    /**
     * Get the toolbar items for the popup.
     * It includes a Save button that is enabled based on the uploaded files.
     */
    getToolbarItems() {
      return [
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible: this.isUserHasPermission,
          options: {
            text: "Save",
            stylingMode: "contained",
            type: "default",
            onClick: this.onSaveAttachments,
            disabled: !this.enableSaveButton,
          },
        },
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible: true,
          options: {
            text: "",
            icon: "close",
            stylingMode: "text",
            type: "default",
            onClick: this.popupHidden,
          },
        },
      ];
    },
    /**
     * Check if the user has permission to create a supplier invoice.
     */
    isUserHasPermission() {
      return FeatureStorage.checkPermission("SupplierInvoice", "create");
    },
    /**
     * Check if the save button should be enabled.
     * In create mode, it is enabled if there are uploaded files.
     * In edit mode, it is enabled based on the enableSaveButton flag.
     */
    isSaveEnabled() {
      if (this.screenMode === "create") {
        return this.uploadedFiles.length > 0;
      } else {
        return this.enableSaveButton;
      }
    },
  },
};
</script>

<style lang="scss">
.gc-popup-sup-inv-files {
  .dx-popup-content {
    .gc-popup-content {
      padding: 12px !important;

      height: 100%;
      .gc-popup-content-inner {
        background-color: white;
        height: 100%;

        .gc-popup-header {
          padding: 12px;

          .file-upload-container {
            padding: 12px;
            border: 1px solid var(--Colors-Border-border-secondary, #eaecf0);

            display: flex;
            flex-direction: column;
            align-items: center;

            > span {
              font-family: Inter;
              font-weight: 400;
              font-size: 12px;
              line-height: 18px;
              letter-spacing: 0%;
              text-align: center;
              color: var(--colors-text-text-tertiary-600, #475467);
            }

            .dx-fileuploader-content {
              display: flex;
              justify-content: center;
              align-items: center;

              .dx-fileuploader-input-wrapper {
                display: flex;
                justify-content: center;
                padding: unset !important;

                .dx-button {
                  background: var(--Colors-Background-bg-brand-solid, #2a95c5);
                  border: 1px solid #2a95c5;
                  box-shadow: 0px 1px 2px 0px #1018280d;

                  .dx-button-content {
                    display: flex;
                    align-items: center;
                  }

                  .dx-button-text {
                    font-family: Inter;
                    font-weight: 600;
                    font-size: 14px;
                    leading-trim: NONE;
                    line-height: 20px;
                    letter-spacing: 0%;
                    color: var(
                      --Component-colors-Components-Buttons-Primary-button-primary-fg,
                      #ffffff
                    );
                  }
                }
              }

              > .dx-fileuploader-files-container {
                display: none;
              }
            }
          }
        }

        .gc-popup-body {
          // padding-top: unset !important ;
          padding: 12px;
          max-height: 400px;
          overflow-y: auto;
          overscroll-behavior: contain;
          -webkit-overflow-scrolling: touch;
          .file-item {
            border: 1px solid var(--Colors-Border-border-secondary, #eaecf0);
            display: flex;
            justify-content: space-between;
            gap: 15px;
            align-items: center;
            padding: 10px 6px 6px 6px;

            .file-name {
              width: 100%;
              display: flex;
              flex-direction: column;

              > span:first-child {
                font-family: Inter;
                font-weight: 500;
                font-size: 14px;
                leading-trim: NONE;
                line-height: 20px;
                letter-spacing: 0%;
                color: var(--colors-text-text-secondary-700, #344054);
              }

              > span:last-child {
                font-family: Inter;
                font-weight: 400;
                font-size: 14px;
                leading-trim: NONE;
                line-height: 20px;
                letter-spacing: 0%;
                color: var(--colors-text-text-tertiary-600, #475467);
              }
            }

            .icon {
              cursor: pointer;
            }
          }

          .file-list-container:not(:last-child) {
            margin-bottom: 12px;
          }

          .file-action {
            cursor: pointer;
          }
        }
      }
    }

    .gc-popup-body-empty {
      padding: 12px;

      > span {
        font-family: Inter;
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        letter-spacing: 0%;
        text-align: center;
        color: var(--colors-text-text-tertiary-600, #475467);
      }
    }
  }
}
</style>
